import React, { Suspense, useContext, useEffect, useState, useRef } from "react";
import Footer from "./footer/Footer";
import Header from "./header/Header";
import { ClientOnly, useClient } from "shared/components/ClientOnly";
import { PopupContext, PopupProvider } from "shared/components/PopupProvider";
import { HeaderVisibilityProvider } from "shared/components/HeaderVisibilityProvider";

function Layout({ children }) {
  const containerRef = useRef(null)
  return (
    <PopupProvider >
      <div ref={containerRef} className="page-layout">
        <HeaderVisibilityProvider containerRef={containerRef}>
          <Header />
          {children}
          <Footer />
        </HeaderVisibilityProvider>
      </div>

      <PopupContainer />
    </PopupProvider>
  )
}


const PopupContainer = () => {
  const popup = useContext(PopupContext)
  return <>
    <ClientOnly
      component={() => import('./popup/Popup')}
      fallback={() => <></>}
      props={{
        card: popup.selectedCard, isOpen: popup.isOpenPopup, onClose: popup.closePopup
      }}
    />
    <ClientOnly
      component={() => import('./popup/Popup')}
      fallback={() => <></>}
      props={{
        isOpen: popup.isOpenImagePopup,
        onClose: popup.closePopup,
        image: popup.selectedImage
      }}
    />
  </>
}

export default Layout;


